<template>
	<div class="comp">
		<el-dialog :title="title" :visible.sync="dialogState" width="65%" :close-on-click-modal="false">
			<el-form>
				<el-row>
					<el-col :span="10" :offset="1">
						<el-form-item label="昵称：" :label-width="formLabelWidth" prop="nick_name">
							<el-input v-model="form.nick_name" autocomplete="off" placeholder="请输入宠物昵称" clearable></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="10" :offset="1">
						<el-form-item label="种类：" :label-width="formLabelWidth">
							<el-radio-group v-model="form.pet_type" @change="typeChange">
								<el-radio :label="'2'">犬</el-radio>
								<el-radio :label="'1'">猫</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="10" :offset="1">
						<el-form-item label="品种：" :label-width="formLabelWidth">
							<el-select class="select" filterable default-first-option v-model="form.category_id" placeholder="请选择品种">
								<el-option v-for="item in typeList" :key="item.id" :label="item.label" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="10" :offset="1">
						<el-form-item label="毛色：" :label-width="formLabelWidth">
							<el-select class="select" filterable allow-create default-first-option v-model="form.pet_color" placeholder="请选择毛色">
								<el-option v-for="item in colorList" :key="item._id" :label="item.name" :value="item.name">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="10" :offset="1">
						<el-form-item label="性别：" :label-width="formLabelWidth">
							<el-radio-group v-model="form.pet_sex">
								<el-radio :label="'公'">公</el-radio>
								<el-radio :label="'母'">母</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
					<el-col :span="10" :offset="1">
						<el-form-item label="用品编号：" :label-width="formLabelWidth">
							<el-input v-model="form.tool_num" autocomplete="off" clearable></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="10" :offset="1" :label-width="formLabelWidth">
						<el-form-item label="出生日期：" :label-width="formLabelWidth">
							<el-date-picker v-model="form.bron_date" @change="changeDatePicker" :picker-options="{disabledDate(time) {return new Date().getTime() < time.getTime()}}" type="date" placeholder="选择日期">
							</el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="10" :offset="1">
						<el-form-item label="年龄：" :label-width="formLabelWidth">
							<el-input v-model="curPetYear" @input="changeCurPetYear" style="width:45%;margin-right: 5%;">
								<template slot="append">年</template>
							</el-input>
							<el-input v-model="curPetMonth" @input="changeCurPetMonth" style="width:45%">
								<template slot="append">月</template>
							</el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="10" :offset="1">
						<el-form-item label="芯片编号：" :label-width="formLabelWidth">
							<el-input v-model="form.eprom_no" autocomplete="off" clearable disabled></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="10" :offset="1">
						<el-form-item label="其他：" :label-width="formLabelWidth">
							<el-checkbox-group v-model="checkList">
								<el-checkbox label="已绝育"></el-checkbox>
								<el-checkbox label="已免疫"></el-checkbox>
							</el-checkbox-group>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="10" :offset="1">
						<el-form-item label="体重：" :label-width="formLabelWidth">
							<el-input autocomplete="off" v-model="form.weight" clearable>
								<template slot="append">kg</template>
							</el-input>
						</el-form-item>
					</el-col>
					<el-col :span="10" :offset="1">
						<el-form-item label="体重说明：" :label-width="formLabelWidth">
							<el-input type="textarea" v-model="form.weight_remark" autocomplete="off" clearable></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="10" :offset="1">
						<el-form-item label="宠物状态：" :label-width="formLabelWidth">
							<el-radio-group v-model="form.status">
								<el-radio :label="'1'">正常</el-radio>
								<el-radio :label="'3'">丢失</el-radio>
								<el-radio :label="'4'">亡故</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
					<!-- <el-col :span="10" :offset="1" v-if="dialog_type=='addPet'">
						<el-form-item label="花生宠物：" :label-width="formLabelWidth">
							<el-radio-group v-model="form.hs_pet">
								<el-radio :label="true">是</el-radio>
								<el-radio :label="false">否</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col> -->
				</el-row>
				<el-row>
					<el-col :span="10" :offset="1">
						<el-form-item label="备注：" :label-width="formLabelWidth">
							<el-input type="textarea" v-model="form.remark" autocomplete="off" clearable></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogState = false">取 消</el-button>
				<el-button type="primary" @click="submit">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				dialogState:true,
				title:'',
				formLabelWidth: '100px',
				
				form: {
					"member_id": "",
					"_id": "",
					"status": "", // 状态 1正常；2删除；3丢失；4亡故
					"nick_name": "",  
					"eprom_no": "",  // 芯片号
					"pet_type": "",  
					"category_id": "",  
					"category_name": "",  
					"pet_features": "",  // 0: 不限制 1:短毛 2:长毛
					"pet_varieties": "",  // 0: 不限制 11:普通狗 12:特种犬 21:普通猫 22:特种猫
					"pet_certificate_no": "",  // 宠物证件编号
					"character": "",  // 性格
					"pet_sex": "",  
					"pet_color": "",  
					"remark": "",  
					"hs_pet": true,  // 是否花生宠物
					"sterilization": 0,  // 绝育
					"immunization": 0,  // 免疫
					"bron_date": "",  // 生日
					"home_date": "",  // 到家时间
					"avatar_pic": "",  // 缩略图
					"tool_num": "",  // 用具编号
					"weight": 0, 
					"weight_remark": "",  
				},
				typeList:[],
				typeList1:[],
				typeList2:[],
				colorList:[],
				curPetYear:0,
				curPetMonth:0,
				checkList: [],
			}
		},
		props:{
			userInfo:{
				default:()=>{
					return {}
				}
			},
			petInfo:{
				default:()=>{
					return {}
				}
			},
			dialog_type:{
				default:'addPet'
			}
		},
		watch:{
			dialogState(n){
				if(n==false){
					this.$emit('submit',"close")
				}
			},
		},
		mounted() {
			if(this.dialog_type==="addPet"){
				this.title = "新增宠物"
				this.addPet();
			}else if(this.dialog_type==="editPet"){
				this.title = "编辑宠物"
				this.editPet()
			}else{
				this.title = this.dialog_type;
			}
			// 获取猫狗分类
			let params = {
				category: '活体'
			}
			this.$http.get('/api/Product/Category/Tree', params).then(res => {
				if(res.code===0){
					for(let i=0;i<res.data[0].children.length;i++){
						let item = res.data[0].children[i];
						if(item.id==='603f7255664b790a9c7d4f61'){
							this.typeList1 = item.children;
						}
						if(item.id==='603f7255664b790a9c7d4f62'){
							this.typeList2 = item.children;
						}
					}
					this.getTypeList()
				}
			})
			// 获取猫狗颜色
			this.getColorList();
		},
		methods: {
			// 修改日期
			changeDatePicker(val){
				let a = this.$public.FAge(val);
				this.curPetYear = a[0];
				this.curPetMonth = a[1];
			},
			changeCurPetYear(){
				this.curPetYear = this.$public.FInt(this.curPetYear)
				let month = parseInt(Number(this.curPetYear)*12+Number(this.curPetMonth));
				this.form.bron_date = this.$public.FBirthday(month)
			},
			changeCurPetMonth(){
				this.curPetMonth = this.$public.FInt(this.curPetMonth)
				let month = parseInt(Number(this.curPetYear)*12+Number(this.curPetMonth));
				this.form.bron_date = this.$public.FBirthday(month)
			},
			// 切换猫狗
			typeChange(){
				this.getTypeList();
				this.form.category_id='';
				this.form.category_name='';
			},
			// 获取毛色列表
			getColorList() {
				let params = {
					"keyword": "",
					"pageIndex": 1,
					"pageSize": 1000
				}
				this.$http.post('/api/DataCenter/List', params).then(res => {
					if (res.code == 0) {
						this.colorList = res.data.data;
					}
				})
			},
			// 获取品种列表
			getTypeList() {
				if(this.form.pet_type==='1'){
					this.typeList = this.typeList1;
				}else if(this.form.pet_type==='2'){
					this.typeList = this.typeList2;
				}
			},
			// 添加宠物
			addPet() {
				this.form = {
					"member_id": this.userInfo._id,
					"_id": "",
					"status": "1", // 状态 1正常；2删除；3丢失；4亡故
					"nick_name": "",  
					"eprom_no": "",  // 芯片号
					"pet_type": "2",  
					"category_id": "",  
					"category_name": "",  
					"pet_features": "",  // 0: 不限制 1:短毛 2:长毛
					"pet_varieties": "",  // 0: 不限制 11:普通狗 12:特种犬 21:普通猫 22:特种猫
					"pet_certificate_no": "",  // 宠物证件编号
					"character": "",  // 性格
					"pet_sex": "公",  
					"pet_color": "",  
					"remark": "",  
					"hs_pet": false,  // 是否花生宠物
					"sterilization": 0,  // 绝育
					"immunization": 0,  // 免疫
					"bron_date": "",  // 生日
					"home_date": "",  // 到家时间
					"avatar_pic": "",  // 缩略图
					"tool_num": "",  // 用具编号
					"weight": 0, 
					"weight_remark": "",
				};
				this.curPetYear = 0;
				this.curPetMonth = 0;
				this.checkList = [];
			},
			// 编辑宠物
			editPet() {
				this.form = {
					"member_id": this.userInfo._id,
					"_id": this.petInfo._id,
					"status": this.petInfo.status?this.petInfo.status.value:'1', // 状态 1正常；2删除；3丢失；4亡故
					"nick_name": this.petInfo.nick_name,
					"eprom_no": this.petInfo.eprom_no,  // 芯片号
					"pet_type": this.petInfo.apply_type?this.petInfo.apply_type.value:'',  
					"category_id": this.petInfo.category_info._id,  
					"category_name": this.petInfo.category_info.name,  
					"pet_features": this.petInfo.pet_features?this.petInfo.pet_features.value:"0",  // 0: 不限制 1:短毛 2:长毛
					"pet_varieties": this.petInfo.pet_varieties?this.petInfo.pet_varieties.value:"0",  // 0: 不限制 11:普通狗 12:特种犬 21:普通猫 22:特种猫
					"pet_certificate_no": this.petInfo.pet_certificate_no,  // 宠物证件编号
					"character": this.petInfo.character,  // 性格
					"pet_sex": this.petInfo.pet_sex,  
					"pet_color": this.petInfo.pet_color,  
					"remark": this.petInfo.remark,  
					"hs_pet": this.petInfo.hs_pet,  // 是否花生宠物
					"sterilization": this.petInfo.sterilization,  // 绝育
					"immunization": this.petInfo.immunization,  // 免疫
					"bron_date": this.petInfo.bron_date,  // 生日
					"home_date": this.petInfo.home_date,  // 到家时间
					"avatar_pic":this.petInfo.avatar_pic,  // 缩略图
					"tool_num": this.petInfo.tool_num,  // 用具编号
					"weight": this.petInfo.weight, 
					"weight_remark": this.petInfo.weight_remark,
				};
				this.curPetYear = this.$public.FAge(this.form.bron_date)[0];
				this.curPetMonth = this.$public.FAge(this.form.bron_date)[1];
				this.checkList = [];
				if (this.petInfo.sterilization == 1) {
					this.checkList.push("已绝育")
				}
				if (this.petInfo.immunization == 1) {
					this.checkList.push("已免疫")
				}
			},
			submit(){
				if(this.$public.isNull(this.form.nick_name)){
					this.$message({
						message: '请录入宠物昵称',
						type: 'error'
					});
					return ;
				}
				if(this.$public.isNull(this.form.pet_type)){
					this.$message({
						message: '请选择宠物品种',
						type: 'error'
					});
					return ;
				}
				let category_name = '';
				if(this.form.pet_type==='1'){
					category_name = this.$public.getMatchingItem(this.typeList1, 'id', this.form.category_id).label;
				}else if(this.form.pet_type==='2'){
					category_name = this.$public.getMatchingItem(this.typeList2, 'id', this.form.category_id).label;
				}
				let params = {
					"member_id": this.form.member_id,
					"_id": '',
					"status": this.form.status,
					"nick_name": this.form.nick_name,
					"eprom_no": this.form.eprom_no,  // 芯片号
					"pet_type": this.form.pet_type,  
					"category_id": this.form.category_id,
					"category_name": category_name,  
					"pet_features": this.form.pet_features.value,  // 0: 不限制 1:短毛 2:长毛
					"pet_varieties": this.form.pet_varieties.value,  // 0: 不限制 11:普通狗 12:特种犬 21:普通猫 22:特种猫
					"pet_certificate_no": this.form.pet_certificate_no,  // 宠物证件编号
					"character": this.form.character,  // 性格
					"pet_sex": this.form.pet_sex,  
					"pet_color": this.form.pet_color,  
					"remark": this.form.remark,  
					"hs_pet": this.form.hs_pet,  // 是否花生宠物
					"sterilization": 0,  // 绝育
					"immunization": 0,  // 免疫
					"bron_date": this.$public.FTime(new Date(this.form.bron_date).getTime(),'YYYY-MM-DD'),  // 生日
					"home_date": this.form.home_date,  // 到家时间
					"avatar_pic":this.form.avatar_pic,  // 缩略图
					"tool_num": this.form.tool_num,  // 用具编号
					"weight": Number(this.form.weight), 
					"weight_remark": this.form.weight_remark,
				}
				let s = this.checkList.join(',');
				if (s.indexOf('已绝育') > -1) {
					params.sterilization = 1
				}
				if (s.indexOf('已免疫') > -1) {
					params.immunization = 1
				}
				if (this.dialog_type == 'addPet') {
					this.$http.post('/api/Pet/Insert', params).then(res => {
						if (res.code == 0) {
							this.$message({
								message: '添加成功',
								type: 'success'
							});
							this.$emit('submit',res.data)
						}
					})
				} else {
					params._id = this.form._id;
					this.$http.post('/api/Pet/Update', params).then(res => {
						if (res.code == 0) {
							this.$message({
								message: '修改成功',
								type: 'success'
							});
							this.$emit('submit',res.data)
						}
					})
				}
			},
		}
	}
</script>
<style lang="scss" scoped>
	.comp {
		
	}
</style>
